import { useCallback } from "react";

const BARREL_ROLL_CLASS = "animate-barrel-roll";
const BARREL_ROLL_DURATION = 1000;

/**
 * Hook that spins the entire page a full 360°, à la the classic
 * "do a barrel roll" Google easter egg.
 *
 * Applies the Tailwind `animate-barrel-roll` animation (defined in
 * tailwind.config.js) to `document.body`, temporarily hiding horizontal
 * overflow so the rotating corners don't produce a scrollbar. It cleans up
 * after itself and ignores repeat triggers while a roll is in progress.
 */
export const useBarrelRoll = () => {
  const rollBarrel = useCallback(() => {
    const body = document.body;
    if (!body || body.classList.contains(BARREL_ROLL_CLASS)) {
      return; // already rolling — ignore re-triggers
    }

    const root = document.documentElement;
    const prevOverflowX = root.style.overflowX;
    root.style.overflowX = "hidden";
    body.classList.add(BARREL_ROLL_CLASS);

    window.setTimeout(() => {
      body.classList.remove(BARREL_ROLL_CLASS);
      root.style.overflowX = prevOverflowX;
    }, BARREL_ROLL_DURATION);
  }, []);

  return { rollBarrel };
};
